import { MainContentSectionLine } from './main-content-section-line'
import {
  MainContentSectionLink,
  MainContentSectionLinkProps
} from './main-content-section-link'

export interface SectionLinkGroupProps {
  lineHeader?: string
  linkItems: MainContentSectionLinkProps[]
}

export interface MainContentSectionLinkGroupProps {
  sectionLinkGroups: SectionLinkGroupProps[]
}

export const MainContentSectionLinkGroup = ({
  sectionLinkGroups
}: MainContentSectionLinkGroupProps) => {
  return (
    <>
      {sectionLinkGroups.map((linkGroup, groupIndex) => {
        const { lineHeader, linkItems } = linkGroup
        return (
          <MainContentSectionLine
            key={`section-link-group-${groupIndex}`}
            lineHeader={lineHeader}
          >
            {linkItems.map((item, index) => (
              <MainContentSectionLink
                key={`${item.id}-section-link-${index}`}
                {...item}
              />
            ))}
          </MainContentSectionLine>
        )
      })}
    </>
  )
}
